import script from "./AuditLogView.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditLogView.vue?vue&type=script&setup=true&lang=js"

import "./AuditLogView.vue?vue&type=style&index=0&id=1aba91d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aba91d8"]])

export default __exports__